module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_resume_title-c1893f0b9abc38d3eae95219f2aaf2f0.png";